import GenericView from 'js/views/generic.view';
import Template from 'js/templates/subscriber.select.listgroup.row.hbs';
import {className, on, tagName, template} from "../adapters/backbone-decorators";

@template(Template)
@tagName('span')
@className('subscriber-row')
class SubscriberSelectListgroupRowView extends GenericView {
    constructor(options) {
        super(options);
        this.CCview = options.CCview;
    }

    render() {
        var theId = this.model.get(this.model.idAttribute);
        super.render();
        this.$el.find(".icon-info-2").parent().bind("click", () => document.location.href = `#${theId}`);
        if (this.CCview.model.get("contactIds").indexOf(this.model.get(this.model.idAttribute)) !== -1) {
            this.$(".list").addClass("selected");
            this.CCview.$(`#listview #group-${this.model.myInitial()}.collapsed .group-title`).click();
            if (!this.CCview.isCampaignScheduled(this.CCview.model) && this.CCview.model.get("campaignId") !== 0) {
                this.$(".list").addClass("disabled");
            }
        }
    }

    isCampaignScheduled(model) {
        return model.get("campaignId") !== 0 &&
            model.get("startDate") &&
            model.get("startDate") > Date.now();
    }

    @on("click")
    select() {
        if (!this.CCview.isCampaignScheduled(this.CCview.model) &&
            this.CCview.model.get("campaignId") !== 0) {
            return;
        }
        var id = this.model.get(this.model.idAttribute);
        var CCmodel = this.CCview.model;
        var attr = "contactIds";
        var existingContacts = CCmodel.get(attr);
        var index = CCmodel.get(attr).indexOf(id);
        if (index === -1) {
            this.$(".list").addClass("selected");
            existingContacts.push(id);
            this.CCview.changeTargeting(existingContacts, "contact");
            this.trigger("ContactSelected", id);
        } else {
            this.$(".list").removeClass("selected");
            existingContacts.splice(index, 1);
            this.CCview.changeTargeting(existingContacts, "contact");
            this.trigger("ContactDeselected", id);
        }
        return false;
    }
}

export default SubscriberSelectListgroupRowView;
